import { createRequest } from '@shared/services';

export interface PostLayoutPublishPropType {
    pageId: string;
    layoutIds: string[];
}

export async function postLayoutPublish({
    pageId,
    layoutIds: layout_ids,
}: PostLayoutPublishPropType) {
    const request = createRequest<Success>({
        url: `/layout/publish${pageId && '/' + pageId}`,
        method: 'POST',
        withAuthorization: true,
        data: {
            layout_ids,
        },
    });

    return request.execute();
}
